import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const SelectorWrapper = styled.div`
  min-width: 160px;
  ${({ theme }) => `
    font-size: ${theme.fontSize.xxs};
    font-weight: ${theme.fontWeight.bold};
  `}
`
